import app                  from "app.controller"
import Filter               from "components/Filter/Filter"
import ProductCol           from "components/Product/ProductCard"
import ProductCard     from "components/Product/ProductCard"
import SearchBarWithOptions from "components/Search/SearchBarWithOptions"
import Spinner              from "components/Spinner/Spinner"
import PropTypes            from "prop-types"
import shop                 from "shop/shop"
import queryString          from "qs"
import React, { Component, Fragment } from "react"
import { Card, Container }  from "semantic-ui-react"
import historyStore         from "stores/historyStore"
import productStore         from "stores/productStore"
import { translateText }    from "translate"
import searchStore          from "stores/searchStore"
import ProductListItem      from "../components/Product/ProductListItem";
import Responsive           from "react-responsive"
import CategoryCard         from "plugin/CategoryShortcuts/CategoryCard"
import categoryStore        from "stores/categoryStore"
import FilterPage           from "pages/FilterPage"
import Collapsible                                                                    from 'react-collapsible';
import {Col, Row} from "elemental-react16"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import { observer } from "mobx-react"
import CategorySliderV2                                                                             from "plugin/CategoryShortcuts/CategorySliderV2"

@observer
export default class SearchPage extends Component {
  
  state = {
    query   : {},
    products: [],
    categories: [],
  }
  
  handleSearch = ( e = {} ) => {
    let q = ""
    if ( e.target && e.target.value ) q = e.target.value
    if ( e.q ) q = e.q
    
    let query = this.state.query
    
    if ( this.state.search !== e ) {
      query.page = 1
    }
    
    this.setState( { search: q, query }, () => {
      //console.log( "SEARCH PAGE", this.state, q.length, q )
      if ( q.length >= 3 ) {
        this.load()
      } else {
        this.setState( {
          products: [],
          categories: [],
          size    : 0
        } )
        return
      }
    } )
  }
  
  onChangeFilter = ( filter ) => {
    this.updateQuery( filter )
  }
  
  addQuery( query ) {
    this.props.history.replace( `${this.props.location.pathname}?${queryString.stringify( query )}` )
    return query
  }
  
  updateQuery( { page, dir, view, sort, pageSize } ) {
    let query = this.state.query
    query.page = page || query.page
    query.dir = dir || query.dir
    query.count = pageSize || query.count
    query.sort = sort || query.sort
    query.q = this.state.search
    query.view = view || query.view
    
    this.addQuery( query )
    this.setState( { query }, () => {
      this.load()
    } )
  }
  
  componentDidMount() {
    if ( searchStore.searchTerm ) {
      console.log( "SEARCH PAGE", searchStore.searchTerm , this.state.search)
      this.setState( { search: searchStore.searchTerm }, this.updateQuery( { page: 1 } ) )
    }
    let search = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    this.setState( {
      loading : true,
      search  : search.q || this.props.match.params.searchTerm || "",
      products: [],
      categories: [],
      filter  : {
      total      : shop.config.standards.ITEMS_PER_PAGE,
      pageSize   : shop.config.standards.ITEMS_PER_PAGE,
      currentPage: 1,
      },
      query   : {
      q    : search.q || "",
      sort : shop.config.standards.SORT || null,
      dir  : shop.config.standards.DIR || null,
      page : search.page || 1,
      count: search.count || 10,
      }
    }, () => {
      this.load()
      app.search.change.add( this.handleSearch )
    } )
    
    
  }

  loadCategories = (fetchCategoryData) => {
    //console.log("LOAD CATEGORIES SEARCH PAGE ", this.state.categories)
    productStore.searchCategories( fetchCategoryData ? this.state.categories : this.state.search, fetchCategoryData )
    .then( response => {
      //console.log( "SEARCH PAGE", response )
      //this.loadCategories(response)
      const categories = response.slice( 0, 9 )
      categories.fakeParent = true
      this.setState( { categories } )
      let { query } = this.state
      query.q = this.state.search
      this.addQuery( query )

    } )
    .catch( err => {
      console.error( err )
    } )
  }
  
  load() {
    let { query } = this.state
    historyStore.set( {
      link   : `/search?q=${this.state.search}`,
      content: `${translateText( "zurück zur Suche" )}`,
    } )
    
    let additionalFilters = []
    
    // if ( cmsStore.config.plugin.hideVariants ) {
    //   // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
    //   let noVariants = {
    //     op:    "equals",
    //     field: "type",
    //     value: "1"
    //   }
    //   const singleItems = { "field": "mainArticle", "op": "equals", "value": "" }
    //   let combinedFilter = [{ "or": [singleItems, noVariants] }]
    //   additionalFilters = additionalFilters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
    // }
    this.setState( { loading: true } )
    
    if(this.state.search.length >= 3){
      this.loadCategories(false)
    }
    console.log("LOADING SEARCH PAGE: ", this.state.search, query.sort, query.dir, query.page)
    productStore.search( this.state.search, {
      filter: additionalFilters,
      count : shop.config.standards.ITEMS_PER_PAGE,
      page  : query.page,
      sort  : query.sort === "sort" ? "search" : query.sort || shop.config.standards.SORT || "des",
      dir   : query.dir || "asc" || shop.config.standards.DIR || "desc",
      artnr : 0
    }, { useArtNr: false } )
      .then( response => {
      let { query } = this.state
      query.q = this.state.search
      let { products = [] } = response
      if( this.state.categories.length === 0 && response.meta && response.meta.cats ){
        this.setState( { categories: response.meta.cats }, () => this.loadCategories(true) )
      }
      this.setState( {
        size   : response.size,
        products
      } )
      this.addQuery( query )
      } )
      .catch( err => {
      console.error( err )
      this.setState( { loading: false } )
      } )
      .finally( () => {
      setTimeout(() => {
        this.setState({ loading: false });
      }, 300);
      } )
  }
  
  componentWillUnmount() {
    app.search.change.remove( this.handleSearch )
  }
  
  render() {
    //console.log( "SEARCH PAGE", this.state )
    let filter = {
      currentPage: Number( this.state.query.page ),
      total      : Number( this.state.size ),
      brand      : String( this.state.query.brand ),
      pageSize   : shop.config.standards.ITEMS_PER_PAGE,
      dir        : this.state.query.dir || shop.config.standards.DIR || "desc",
      view       : this.state.query.view || shop.config.standards.VIEW || "grid",
      sort       : this.state.query.sort || shop.config.standards.SORT || "des"
    }
    
    const { loading, search } = this.state
    const { lastSearchURL } = productStore
    
    let filterSection =
    <Fragment>
      <Responsive minWidth={790}>
        <section className="cf pb3 pt3">
          <Filter hidePageSize={true} onChange={this.onChangeFilter} {...filter} />
        </section></Responsive>
      <Responsive maxWidth={789}>   
      <section className="cf pb3 pt3">
        <Filter hidePageSize={true} onChange={this.onChangeFilter} {...filter} />
        </section></Responsive>
    </Fragment>
        let filterSectionOnlyPagination =
        <Fragment>
          <Responsive minWidth={790}>
            <section className="cf pb3 pt3">
              <Filter hidePageSize={true} onChange={this.onChangeFilter} {...filter} />
            </section></Responsive>
          <Responsive maxWidth={789}>   
          <section className="cf pb3 pt3">
            <Filter hidePageSize={true} onChange={this.onChangeFilter} onlyPagination={true} {...filter} />
            </section></Responsive>
        </Fragment>
    
    const { products, categories } = this.state
    
    let backLink = shop._lastLocation || "/"
    console.log("SEARCH PAGE RENDER: ", this.state, backLink)
    return (
      <div className={products.length > 0 ? "SearchPageActive2 headerTopper" : "SearchPage2 headerTopper"}>
        
        <Container className={""}>
          
          {<h1 className="f2 fw6 ">{translate("Suche nach")} {search}</h1>}
          {/*<div className="flex flex-row justify-between items-top pt3">*/}
          {<Responsive maxWidth={789}>  <SearchBarWithOptions loading={loading} results={products}/></Responsive>}
          {<Responsive minWidth={790}>  <SearchBarWithOptions loading={loading} results={products}/></Responsive>}
          {/* */}
          {/*</div>*/}
          <div className="pt2-ns pb3-ns">
            <div className={"pb3"}>
              {shop.config.plugin.categorySearch && <Fragment>
                <div className="pt4 f3 fw6 pb0">{translate("Kategorien mit den besten Treffern")}</div>
                {categories && categories.length > 0 && <CategorySliderV2 categoryforCards1={{children: categories}} translate={translateText}/>}
              </Fragment>}
              {/*              <Responsive minWidth={790}>
                {!loading && categories && categories.length > 0 && <div className="pt2 pb2 bb bt b--black-10">
                <div className="pb3 tc" style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }}>


                {!loading && categories && categories.length > 0 ? (
                categories.slice(0, 3).map(category => {
                  return <CategoryCard key={category.map_id} category={category} fakeParent={true} hasParents={category.parent != "" ? false : false} />  // 
                })
                  ) : (<div></div>)}
                  </div></div>}
              </Responsive>
              <Responsive maxWidth={789}>
                {!loading && categories && categories.length > 0 && <div className="pt2 pb2 bb bt b--black-10">
                  <Col className=" pa2 bg-silver pl2" >
                  <Collapsible tabIndex={0} open={false} trigger="Kategorien mit den besten Treffern">
                  <div className="pb3 " style={{ }}>


                    {!loading && categories && categories.length > 0 ? (
                      categories.slice(0, 3).map(category => {
                        return <CategoryCard key={category.map_id} category={category} fakeParent={true} hasParents={category.parent != "" ? false : false} />  // 
                      })
                    ) : (<div></div>)}
                  </div>
                  </Collapsible>
                  </Col>
                  </div>}
              </Responsive> */}


              {/*<div className="mw6 center">*/}
              {/*<SearchBar/>*/}
              {/*</div>*/}
              {this.state.size > 0 ? filterSectionOnlyPagination : null}
              {loading && <Spinner/>}
              <div className=""></div>
              <section className="mb5">
                {!loading && <div>{(!loading && products && products.length > 0) ? null : <div
                  className="black-80 tc pa4">{translate( "Keine Produkte oder Kategorien gefunden." )}</div>}</div>}
                {!loading && <React.Fragment>
                  {(filter.view === "list") && <div>
                    {this.state.products.map( product => <ProductListItem
                      referrer={`/search/${location.search}`}
                      key={product.map_id} product={product}/> )}
                  </div>}
                  {(filter.view === "grid") && <div className="flex flex-row items-center justify-center">
                    <Card.Group itemsPerRow={4} className="flex flex-row items-center justify-center" doubling>
                    {this.state.products.map( product => <ProductCard
                      referrer={`/search/${location.search}`}
                      sm="1/2"
                      key={product.map_id}
                      product={product}/> )
                    }
                  </Card.Group>
                  </div>
                  }
                </React.Fragment>}
              </section>
              <div className="pb4">
                {this.state.size > 0 ? filterSectionOnlyPagination : null}
              </div>
            </div>
          </div>
        </Container>
      </div>
    
    );
  }
}

SearchPage.propTypes = {
  params: PropTypes.object, filter: PropTypes.object, location: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/pages/SearchPage.js